/** Shared confirmation dialog for destructive consultation actions. */
export function ConfirmationModal({
  isOpen,
  message,
  onClose,
  onConfirm,
  isConfirming = false,
  confirmLabel = "Yes",
  cancelLabel = "No",
}) {
  if (!isOpen) return null;

  return (
    <div className="modal DeleteModal" onClick={onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()}>
        <button
          aria-label="Close confirmation"
          className="CloseButton"
          onClick={onClose}
          type="button"
        />
        <h3>{message}</h3>
        <ul className="ButtonList">
          <li>
            <button
              className="ModalCloseBtn"
              disabled={isConfirming}
              onClick={onConfirm}
              type="button"
            >
              {confirmLabel}
            </button>
          </li>
          <li>
            <button className="CancelBtn" onClick={onClose} type="button">
              {cancelLabel}
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}
